var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSocialPinterest = function SvgSocialPinterest(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.6,10.27a4,4,0,0,1-.16-1.15,5.46,5.46,0,0,1,5.68-5.52c3.1,0,4.8,1.89,4.8,4.42,0,3.32-1.47,6.13-3.66,6.13-1.21,0-1.63-.92-1.35-2.14.42-1.75,2.71-4.66,0-5.26S8.78,9.59,8.73,11.15l-1.66,7a14.51,14.51,0,0,0,0,4.91.17.17,0,0,0,.31.08A13.85,13.85,0,0,0,9.67,19c.16-.58.75-2.8.75-2.8a3.7,3.7,0,0,0,3.16,1.61c4.15,0,7.13-4.54,7.13-9.61,0-3.83-3.25-7.4-8.18-7.4-6.14,0-9.24,4.4-9.24,8.07a5.36,5.36,0,0,0,2,4.57Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSocialPinterest);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "social-pinterest.4e6a1399588ed0008302b3698aabf81d.svg";